
export const topicRoutes = [
  {
    path: '/topics',
    meta: { title: 'Topics' },
    name: 'Topics',
    component: () => import('../views/topic/Index.vue')
  }
]
